import React, { useEffect, useState } from 'react';

export default function TemplatesForm(props) {
    const [names, setNames] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (props.formData.length > 0) {
            const datForm = props.formData[0];
            setNames(datForm["names"]);
            setDescription(datForm["description"]);
        } else {
            setDescription(localStorage.getItem("description"));
            setNames(localStorage.getItem("names"));
        }
    }, [props]);
    
    return (
        <>
            <div className="row">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Nombres</label>
                                <input id="name"
                                    name="name"
                                    type="text"
                                    maxLength={100}
                                    value={names}
                                    onChange={e => {
                                        setNames(e.target.value.replace(/[^a-z\s]/gi, ''))
                                        localStorage.setItem('names', e.target.value.replace(/[^a-z\s]/gi, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar un nombre" />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Descripción</label>
                                <input id="description"
                                    name="description"
                                    type="text"
                                    maxLength={100}
                                    value={description}
                                    onChange={e => {
                                        setDescription(e.target.value.replace(/[^a-z\s]/gi, ''))
                                        localStorage.setItem('description', e.target.value.replace(/[^a-z\s]/gi, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar una breve descripción" />
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}
